import { Box, Skeleton, Grid } from '@mui/material';

export default function WorkSpaceDialogeContentSkeleton() {
  return (
    <Grid
      container
      direction='column'
      justifyContent='center'
      alignItems='center'
    >
      <Grid item flex={1} display='flex' margin={2}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'Row',
            borderRadius: '20px',
          }}
          gap={2}
        >
          <Skeleton variant='rectangular' width={230} height={230} sx={{ borderRadius: '20px'}} />
          <Skeleton variant='rectangular' width={230} height={230} sx={{ borderRadius: '20px'}}/>
        </Box>
      </Grid>
    </Grid>
  );
}
